import { IntlProvider } from 'react-intl';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import en from '../locales/en.json';
import ru from '../locales/ru.json';
import { resolveLocale } from '../localization/intl.ts';
import { App } from './App.tsx';
import { authClient } from './lib/auth-client.ts';
import './styles.css';

const messages = { en, ru };

function LocalizedApp() {
  const session = authClient.useSession();
  const locale = resolveLocale(
    session.data?.user.locale ?? navigator.languages[0] ?? navigator.language,
  );

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <App />
    </IntlProvider>
  );
}

const root = document.querySelector('#root');

if (!(root instanceof HTMLElement)) {
  throw new Error('Root element is missing');
}

createRoot(root).render(
  <StrictMode>
    <LocalizedApp />
  </StrictMode>,
);
